# Prendo la posizione scrollata [left, top]
document.getScroll = ->
  if window.pageYOffset != undefined
    return [pageXOffset, pageYOffset]
  else
    d = document
    r = d.documentElement
    b = d.body
    sx = r.scrollLeft || b.scrollLeft || 0
    sy = r.scrollTop || b.scrollTop || 0
    return [sx, sy]

toggle_btn_petizione =->
  if $("#template-petizione").length > 0 and $("#latest-petizioni").length > 0
    documentScroll = document.getScroll()
    scroll_top = documentScroll[1]
    if scroll_top >= ($("#latest-petizioni").position().top - $(window).height())
      $('#template-petizione .content-cols .col-right .content-btn').addClass('hidden')
    else
      $('#template-petizione .content-cols .col-right .content-btn').removeClass('hidden')

$ ->
  toggle_btn_petizione()

  progress_bar = $('#template-petizione .content-cols .col-right .progress .progress-bar div')
  if progress_bar.length > 0
    setTimeout ->
      progress_bar.css
        width: "#{progress_bar.data().width}%"
    , 1000

  $('.box-petizione .progress-bar div').each ->
    bar = $(@)
    setTimeout ->
      bar.css
        width: "#{bar.data().width}%"
    , 1000

  # Rimuovo i <p> vuoti nel testo
  $('#template-petizione .content-cols .col-left p').each ->
    $(@).remove() if $(@).text().trim() == ''

  $('#content-article p').each ->
    $(@).remove() if $(@).text().trim() == ''

  $('#post-template-1-foto-centrale div.clear').remove()

  $('a.btn[href="#"]').on 'click', (event)->
    event.preventDefault()

  last_enrollments_box = $('#template-petizione .content-cols .col-right .last-enrollments > div')
  if last_enrollments_box.length > 0
    last_enrollments_box.css
      marginTop: 0

  window.add_merendator_tag = ->
    form = $('#newsletter-form')
    $.ajax
      url: form.data().url
      type: 'POST'
      data: form.serialize()
      complete: ->
        $('#overlay-newsletter').remove()
        alert form.data('message-success')
      success: ->
        console.log 'DAI CAZZO CHE È ANDATA!!!'
      error: ->
        console.log arguments

  $('.content-select').each ->
    cs = $(@)
    cs.find('select').on 'focusin', ->
      cs.addClass('focusin')
    cs.find('select').on 'focusout', ->
      cs.removeClass('focusin')

  $('.mobile-menu').on 'click', (event)->
    event.preventDefault()
    box = $(@).parents('.right-header')
    if box.hasClass('open') then box.removeClass('open') else box.addClass('open')

  if $('#template-petizione #post-template-1-foto-centrale .content-post-img').length > 0
    box_img = $('#template-petizione #post-template-1-foto-centrale .content-post-img').clone()
    box_img.find('a').removeAttr('style')
    box_img.find('img').removeAttr('style').attr('data-rac', 'true')
    $('#template-petizione .content-cols').prepend box_img
    if $(window).width() < 841
      data_resize_and_center()

$(document).on 'click', (event)->
  target = event.target
  # Chiudo il menu
  if $('#header .right-header').hasClass('open') && !$(target).hasClass('menu-menu-header-container') && $(target).parents('.menu-menu-header-container').length == 0 && !$(target).hasClass('mobile-menu') && $(target).parents('.mobile-menu').length == 0
    $('#header .right-header').removeClass('open')

$(window).on 'resize', ->
  w_window = $(window).width()
  if $('#post-template-1-foto-centrale').length == 1
    $('img[data-rac="false"]').removeAttr('style').attr('data-rac', 'true')
    data_resize_and_center()

$(document).on 'scroll', (event)->
  toggle_btn_petizione()